import { useCallback, useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import type { StoppedByFilterModel } from './types';
import { dashboardFilterAtom } from '../../filterAtom';

export const useStoppedByFilter = (model: StoppedByFilterModel | null) => {
  const setDashboardFilter = useSetAtom(dashboardFilterAtom);
  const previousModelReference = useRef<StoppedByFilterModel | null>(null);

  const updateAtom = useCallback(
    (newModel: StoppedByFilterModel | null) =>
      setDashboardFilter((previousFilter) => ({
        ...previousFilter,
        stoppedByUserIds:
          newModel?.stoppedByUserIds && newModel.stoppedByUserIds.length > 0
            ? newModel.stoppedByUserIds
            : [],
      })),
    [setDashboardFilter]
  );

  useEffect(() => {
    const currentIds = model?.stoppedByUserIds || [];
    const previousIds = previousModelReference.current?.stoppedByUserIds || [];

    const hasChanged =
      currentIds.length !== previousIds.length ||
      currentIds.some((id, index) => id !== previousIds[index]);

    if (hasChanged) {
      updateAtom(model);
      previousModelReference.current = model;
    }
  }, [model, updateAtom]);
};

